export const ALERT_DEFAULT_TEXT = 'Are you sure?';
export const CANCEL = 'Cancel';

export const UPLOAD = 'Upload';
export const DROP_HERE = 'Drop Here';
export const CONNECTING = 'Connecting...';

export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const SHORT_MONTHS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
export const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const SHORT_DAYS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
export const GO_TO_TODAY = 'Go to today';
export const AND = 'and';
export const MORE = 'more';
export const NOW = 'now';
export const YESTERDAY = 'Yesterday';
export const TODAY = 'Today';
export const ERR_FETCH_FILE_TITLE = 'Cannot Open File';
export const ERR_FETCH_FILE_TXT = 'Sorry, something went wrong';
export const CAMERA_ROLL_PERMISSION = 'Please give permission to access your photos in order to share photos';
export const DIAL_CODE = 'Dial Code';
export const PHOTOS = 'Photos';
export const VIDEOS = 'Vidoes';
export const CONFIRM = 'Confirm';
export const SELECT_DATE = 'SELECT_DATE';
export const YES = 'Yes';
export const CONFIRMA_REMOVE_ITEM = item => `Are you sure you want to delete ${item}?`;



// WEBPACK FOOTER //
// ./src/lang/en/core.js